/* Action Types */
export const REGISTER_FOR_CATALOG_FAIL = 'la/ui/registerForCatalog/FAIL';
export const REGISTER_FOR_CATALOG_REQUEST = 'la/ui/registerForCatalog/REQUEST';
export const REGISTER_FOR_CATALOG_SUCCESS = 'la/ui/registerForCatalog/SUCCESS';
